import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllOfficeAction, removeOfficeAction } from '../../../../utils/redux/office/officeActions';
import { Link } from 'react-router-dom';

const OfficeListing = () => {
    const dispatch = useDispatch();
    const { offices } = useSelector(state => state.office);

    useEffect(() => {
        dispatch(fetchAllOfficeAction());
    }, []);

    const handleDelete = (id) => {
        if (window.confirm("Delete office?")) {
            dispatch(removeOfficeAction(id));
        }
    };

    return (
        <div>
            <div className="d-flex justify-content-between my-3">
                <h3>Offices</h3>
                <Link to="/create-office" className="btn btn-primary">
                    + Add Office
                </Link>
            </div>

            <table className="table">
                <thead>
                    <tr>
                        <th>Label</th>
                        <th>Type</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {offices?.map(o => (
                        <tr key={o._id}>
                            <td>
                                <Link to={`/offices/${o._id}`}>
                                    {o?.label}
                                </Link>
                            </td>
                            <td>{o.type}</td>
                            <td>{o.address?.city?.name}</td>
                            <td>{o.address?.state?.name}</td>
                            <td>
                                <Link to={`/offices/${o._id}/edit`} className="btn btn-sm btn-warning">
                                    Edit
                                </Link>
                                <button
                                    className="btn btn-sm btn-danger ms-2"
                                    onClick={() => handleDelete(o._id)}
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default OfficeListing;